import { trackingAxios } from 'config/api/tracking'
import { ICompanyRepository } from '../domain/ICompanyRepository'
import {
    CompanyCreateRequest,
    CompanyDetails,
    CompanyFilters,
    CompanyList,
} from '../domain/company'
import { CompanyAdapter } from './CompanyAdapter'

interface ApiCompanyResponse {
    id: number
    name: string
    warehouse_count: string
    created_at: string
}

interface ApiResponse {
    totalItems: number
    items: ApiCompanyResponse[]
    page: number
    size: number
}
export class AxiosCompanyRepository implements ICompanyRepository {
    constructor() {}

    async get(filters: CompanyFilters): Promise<CompanyList> {
        try {
            const response = await trackingAxios.get<ApiResponse>('/company', {
                params: filters,
            })

            return {
                totalItems: response.data.totalItems,
                page: response.data.page,
                size: response.data.size,
                items: response.data.items.map((item) =>
                    CompanyAdapter.toCompany(item)
                ),
            }
        } catch (error) {
            console.error(
                '[AxiosCompanyRepository] Error fetching companies:',
                error
            )
            throw error
        }
    }

    async getById(id: number): Promise<CompanyDetails> {
        try {
            const response = await trackingAxios.get<CompanyDetails>(
                `/company/${id}`
            )
            return CompanyAdapter.toCompanyDetails(response.data)
        } catch (error) {
            console.error(
                '[AxiosCompanyRepository] Error fetching company by id:',
                error
            )
            throw error
        }
    }

    async create(data: CompanyCreateRequest): Promise<CompanyCreateRequest> {
        try {
            const response = await trackingAxios.post<CompanyCreateRequest>(
                `/company`,
                data
            )
            return response.data
        } catch (error) {
            console.error(
                '[AxiosCompanyRepository] Error fetching company by id:',
                error
            )
            throw error
        }
    }
}
